import { ColumnsType, ColumnType } from 'antd/lib/table';
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { percentRender } from 'shared/components/Render/PercentRender';
import { priceRender } from 'shared/components/Render/PriceRender';
import { twoDigitRounded } from 'shared/components/Render/TwoDigitsRounder';
import { ItemsStocks } from '../components/ItemsStocks';
import { OrderItems, ordersSelectors } from '../stores';
import { OrderStatusTag } from '../components/OrderStatusTag';

export function useItemsColumns(): ColumnsType<OrderItems> {
    const { t } = useTranslation();

    const DEFAULT_COLUMNS: ColumnsType<OrderItems> = [
        {
            title: t("Orders.Columns.reference"),
            dataIndex: 'reference',
            key: 'reference',
            sorter: (a, b) => a.reference.localeCompare(b.reference)
        },
        {
            title: t("Orders.Columns.designation"),
            dataIndex: 'designation',
            key: 'designation'
        },
        {
            title: t("Orders.Columns.deliveredQuantity"),
            dataIndex: 'deliveredQuantity',
            key: 'deliveredQuantity',
        },
        {
            title: t("Orders.Columns.wantedQuantity"),
            dataIndex: 'wantedQuantity',
            key: 'wantedQuantity'
        },
        {
            title: t("Orders.Columns.urgentFlag"),
            dataIndex: 'isUrgent',
            key: 'isUrgent',
            render: (value) => typeof value === 'boolean' && !!value ? t("Generic.Actions.Yes") : t("Generic.Actions.No")
        },
        {
            title: t("Orders.Columns.unitPrice"),
            dataIndex: 'price',
            key: 'price',
            render: (value) => priceRender(twoDigitRounded(value)),
        },
        {
            title: t("Orders.Columns.discountRate"),
            dataIndex: 'discountRate',
            key: 'discountRate',
            render: percentRender,
        },
        {
            title: t("Orders.Columns.vat"),
            dataIndex: 'vat',
            key: 'vat',
            render: percentRender,
        },
        {
            title: t("Orders.Columns.amount"),
            dataIndex: 'amount',
            key: 'amount',
            render: (_value, record) => priceRender(twoDigitRounded((record.price * (1 - record.discountRate / 100)) * record.deliveredQuantity)),
        },
        {
            title: t("Orders.Columns.dmsAvailableQuantity"),
            dataIndex: 'dmsAvailableQuantity',
            key: 'dmsAvailableQuantity',
            render: (_: number, record: OrderItems) => <ItemsStocks orderItem={record} />
        },
        {
            title: t("Orders.Columns.status"),
            key: 'currentItemStatus',
            dataIndex: 'currentItemStatus',
            render: (status: number) => <OrderStatusTag status={status} />,
        },
    ]

    const [columns, setColumns] = useState(DEFAULT_COLUMNS)
    const orderByRef = useSelector(ordersSelectors.getOrder).data;

    useEffect(() => {
        if (!orderByRef) return;

        setColumns(DEFAULT_COLUMNS.filter((column: ColumnType<OrderItems>) =>
            (!((column.dataIndex === "dmsAvailableQuantity") && (orderByRef.content[0]?.status !== 0)))
        ))

    }, [orderByRef])

    return columns;
}